import { ClassTeam } from '../pages/tourDetails/TournamentClasses/components/ClassesTag/ClassesTag';

export const imgOptionTeamLabel = (team: ClassTeam) => ({
    value: team.id,
    label: `${team.name} (${team.seed})`,
    logo: team.logo,
    seed: team.seed,
});
